<template lang='pug'>
  r-form(
    ref='form'
    reset-text='restablecer'
    submit-text='guardar'
    v-bind='formProps'
    v-model='whPack'
    @reset='submitReset'
    @submit='submitUpdate'
    )
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm } from '@/components/reusable_components/next'
  import translatorService from '@/services/translator'
  //
  import WhPackFields from '@/views/Warehouse/WhPack/WhPackFields'
  import WhProductModel from '@/models/Warehouse/WhProduct'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
    },
    computed: {
      fieldsProps() {
        return {
          upc_codes: this.whPack.upc_codes,
        }
      },
      formProps() {
        return {
          fields: WhPackFields.update(this.fieldsProps),
          loading: this.loading,
          title: `editar pack`
        }
      },
    },
    data() {
      return {
        loading: true,
        whPack: {
          item_quantity: '',
        },
        whPackUPCCodes: [],
      }
    },
    methods: {
      async getWhPack() {
        return WhProductModel
          .append('branch_offices,sale_prices')
          .include('wh_pack,wh_subfamily')
          .find(this.$route.params.id)
      },
      mapBranchOffice(branchOffice) {
        //
        branchOffice.name = branchOffice.g_branch_office.name
        branchOffice.id = branchOffice.g_branch_office.id
        //
        return branchOffice
      },
      setWhPack(whPack) {
        //
        whPack.branch_offices = whPack.branch_offices.map(this.mapBranchOffice)
        whPack.item_quantity = Number(whPack.wh_pack.item_quantity)
        whPack.wh_family_id = whPack.wh_subfamily.wh_family_id
        whPack.wh_item_id = whPack.wh_pack.wh_item_id
        whPack.wh_product_id = whPack.id
        //
        whPack.sale_prices.forEach((price, idx) => {
          whPack.branch_offices[idx].sale_price = price.sale_price
        })
        //
        this.whPack = whPack.reset()
        //
        this.loading = false
      },
      showUpdateError(event) {
        console.log({ event })
        return this.showErrorSnackbar(translatorService(WhProductModel, event.response.data))
      },
      showUpdateSuccess() {
        return this.showSuccessSnackbar('Pack actualizado exitosamente.')
      },
      submitReset() {
        this.getWhPack().then(this.setWhPack)
      },
      submitUpdate() {
        return this
          .toWait(true)
          .then(this.toUpdate)
          .then(this.showUpdateSuccess)
          .then(this.toRedirect)
          .catch(this.showUpdateError)
          .then(this.toWait)
      },
      toUpdate() {
        return this
          .whPack
          .toPack()
          .toUpdate()
          .save()
      },
      toRedirect() {
        this.$router.push({ name: 'wh-pack-list' })
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle('Editar pack')
    },
    mounted() {
      this.submitReset()
    }
  }
</script>